import React from "react";
import {Drawer, Form, Input, Typography} from "antd";
import {useIsMobile} from "../../hooks/breakpoint.hook";

const YEARS = [2022, 2023, 2024]

/**
 * Целевые показатели по годам. Раньше форма жила прямо в разметке страницы,
 * ящик имел ширину 30 % (на телефоне это 113 px), а поля разъезжались по
 * колонкам antd. Здесь ширина адаптивная, а поля сгруппированы по годам.
 */
export const TargetsDrawer = ({visible, onClose, form, values, onChange}) => {
    const isMobile = useIsMobile()

    return <Drawer title={"Целевые показатели"} placement={"right"} visible={visible} onClose={onClose}
                   width={isMobile ? '100%' : 420} bodyStyle={{padding: 16}}>
        <Typography.Paragraph type={"secondary"} style={{fontSize: 13}}>
            Значения используются как ориентир на графиках дожития: показываются
            отдельной линией «Целевое значение».
        </Typography.Paragraph>

        <Form form={form} layout={"vertical"} initialValues={values}
              onValuesChange={(changed, all) => onChange(all)}>
            <div className={"targets"}>
                <div className={"targets__head"}>
                    <span>Год</span>
                    <span>На учёте 5 лет и более, %</span>
                    <span>Одногодичная летальность, %</span>
                </div>
                {YEARS.map(year => (
                    <div className={"targets__row"} key={year}>
                        <span className={"targets__year"}>{year}</span>
                        <label className={"targets__field"}>
                            <span className={"targets__label"}>На учёте 5 лет и более, %</span>
                            <Form.Item name={`y5f${year}`} noStyle><Input inputMode={"decimal"}/></Form.Item>
                        </label>
                        <label className={"targets__field"}>
                            <span className={"targets__label"}>Одногодичная летальность, %</span>
                            <Form.Item name={`y1f${year}`} noStyle><Input inputMode={"decimal"}/></Form.Item>
                        </label>
                    </div>
                ))}
            </div>
        </Form>
    </Drawer>
}

export default TargetsDrawer
